import React from "react";
import Header from "../components/Header/Header";
import HeroCarousel from "../components/HeroCarousel/HeroCarousel";
import Sobre from "../components/Sobre/Sobre";
import NossosProdutos from "../components/NossosProdutos/NossosProdutos";
import Contato from "../components/Contato/Contato";
import Rodape from "../components/Rodape/Rodape";
import SEOHead from "../components/SEO/SEOHead";

import "../App.css";
import "../styles/Button.css";

const SITE_URL = "https://www.hlsoftware.com.br";

const homeJsonLd = [
    {
        "@type": "WebSite",
        name: "HL Software",
        url: SITE_URL + "/",
        description:
            "HL Software: desenvolvimento de SaaS sob medida, automação de processos e produtos digitais para escalar o seu negócio.",
        inLanguage: "pt-BR",
    },
    {
        "@type": "Organization",
        name: "HL Software",
        url: SITE_URL + "/",
        logo: {
            "@type": "ImageObject",
            url: SITE_URL + "/og-image.png",
            width: 1200,
            height: 630,
        },
        description:
            "Empresa especializada em desenvolvimento de software SaaS sob medida, automação de processos e produtos digitais.",
        areaServed: "BR",
        sameAs: [
            "https://www.instagram.com/hlsoftware",
            "https://www.linkedin.com/company/hlsoftware",
        ],
        contactPoint: {
            "@type": "ContactPoint",
            contactType: "sales",
            availableLanguage: "Portuguese",
        },
    },
];

export default function Home() {
    return (
        <div className="App">
            <SEOHead
                title="HL Software — Desenvolvimento de SaaS e Automação para Empresas"
                description="HL Software cria SaaS sob medida, automatiza processos e entrega produtos digitais para empresas de todo o Brasil. Transforme seu negócio com software de alta performance."
                canonical={SITE_URL + "/"}
                ogType="website"
                jsonLd={homeJsonLd}
            />
            <Header />
            <HeroCarousel />
            <main className="main-content">
                <Sobre />
                <NossosProdutos />
                <section id="contato">
                    <Contato />
                </section>
            </main>
            <Rodape />
        </div>
    );
}
